import { canShowEmailCalendarIntegration } from "./kjuupIoEntitlement";
import { resolveStripeFlags } from "./stripeFeature";

/**
 * Daily report unread badges must never show unless this user currently has
 * an assigned Kjuup.io account (email/calendar + active plan). After cancel
 * or seat removal, leftover briefing rows must not inflate Rooms, tabs,
 * pinned rooms, company chips, or Nachrichten.
 */
export function shouldShowDailyBriefingCounters(user, profile, subscription) {
  const sub = subscription || {};
  const {
    stripeFeatureEnabled,
    companyStripeFeatureEnabled,
    isKjuupPlusMember,
    stripeUiEnabled,
  } = resolveStripeFlags(profile, sub);
  const hasActiveKjuupIoPlan = !stripeUiEnabled || !!sub.active;
  const emailFeatureEnabled = canShowEmailCalendarIntegration({
    isKjuupPlusMember,
    hasActiveKjuupIoPlan,
    showCompanyTrialEndedNote: !!sub.showCompanyTrialEndedNote,
    stripeFeatureEnabled,
    companyStripeFeatureEnabled,
  });
  // Reports are only visible with an assigned Kjuup.io account. After cancel
  // (or seat removal) leftover unread briefing rows must not keep badges.
  return emailFeatureEnabled && hasActiveKjuupIoPlan;
}
